module.exports = __webpack_public_path__ + "glyphicons-halflings-regular-aafafdc0.e49d52e74b7689a0727d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/bootstrap/glyphicons-halflings-regular-aafafdc0.ttf
// module id = 453
// module chunks = 2